import { useEffect, useRef, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ProjectCover({ project, onChanged }) {
  const [src, setSrc] = useState("");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    let u = "";
    if (project.image_path) api.get(`/client-projects/${project.id}/image`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setSrc(u); }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [project.id, project.image_path]);
  const upload = async (file) => {
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", file); await api.post(`/client-projects/${project.id}/image`, fd); toast.success("Image principale enregistrée"); onChanged(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="relative h-36 rounded-lg overflow-hidden border bg-slate-100 group" data-testid="cp-cover">
      {src ? <img src={src} alt="" className="h-full w-full object-cover" data-testid="cp-cover-img" /> : <div className="h-full flex items-center justify-center text-xs text-slate-400">Aucune image principale</div>}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} data-testid="cp-cover-input" />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="cp-cover-upload"
        className="absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-md bg-white/90 px-2.5 py-1.5 text-xs font-semibold shadow hover:bg-white">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="h-3.5 w-3.5" />}{src ? "Changer l'image" : "Ajouter une image"}</button>
    </div>
  );
}
